module.exports = __webpack_public_path__ + "img/Delowe Station Concepts_Page_2.b8d16d05.jpg";